import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../styles/navbar.css";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo-container">
          <img
            src="/logo.svg"
            alt="Erin Counselling Logo"
            className="navbar-logo"
          />
          <p>Erin Robinson Counselling</p>
        </Link>
        <button
          className={`navbar-toggle ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="navbar-toggle-bar"></span>
          <span className="navbar-toggle-bar"></span>
          <span className="navbar-toggle-bar"></span>
        </button>
        <ul className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
          <li className="navbar-item">
            <NavLink to="/" className="navbar-link" end onClick={closeMenu}>
              Home
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink to="/about" className="navbar-link" onClick={closeMenu}>
              About
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink to="/services" className="navbar-link" onClick={closeMenu}>
              Services
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink to="/approach" className="navbar-link" onClick={closeMenu}>
              Approach
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink to="/faq" className="navbar-link" onClick={closeMenu}>
              FAQ
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink to="/fees" className="navbar-link" onClick={closeMenu}>
              Fees
            </NavLink>
          </li>
          <li className="navbar-item">
            <NavLink to="/contact" className="navbar-link" onClick={closeMenu}>
              Contact
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
